import { gql } from "graphql-request"
import { ServiceGraphql } from "./Graphql"

export const graphCustomerLogin = async (phone, password) => {
  const CUSTOMER_LOGIN = gql`
  mutation LoginConsumer($data: LoginConsumerInput!) {
    LoginConsumer(data: $data) {
      isFirstLogin
      refreshToken {
        token
      }
      sessionId
      customer {
        authenType
        baseAddress
        cardAddress
        clientNumber
        company
        customerName
        customerReferenceId
        dob
        email
        flag
        gender
        id
        idCardNumber
        idCardType
        issueDate
        issuePlace
        nationality
        occupationId
        phoneNumber
        positionId
        salary
        perAddress
      }
      accessToken {
        token
      }
    }
  }
  `

  const variables = {
    "data": {
      "password": password,
      "phoneNumber": phone,
      "platform": 'WEB'
    }
  }

  const response = await ServiceGraphql.request(CUSTOMER_LOGIN, variables)
  return response.LoginConsumer;
};

export const graphUserForgotPass = async (email, username) => {
  const USER_FORGOT_PASS = gql`
  mutation ForgotPassword($email: String!, $userType: UserType!, $username: String!) {
    ForgotPassword(email: $email, userType: $userType, username: $username)
  }
  `

  const variables = {
    "email": email,
    "userType": 'CONSUMER',
    "username": username
  }

  const response = await ServiceGraphql.request(USER_FORGOT_PASS, variables);
  return response.ForgotPassword
};

export const graphUserPassReset = async (code, newPass, userId) => {
  const USER_RESET_PASS = gql`
  mutation ChangePasswordForgot($code: String!, $newPassword: String!, $userId: Int!, $userType: UserType!) {
    ChangePasswordForgot(code: $code, newPassword: $newPassword, userId: $userId, userType: $userType)
  }
  `

  const variables = {
    "code": code,
    "newPassword": newPass,
    "userId": parseInt(userId),
    "userType": 'CONSUMER'
  }

  const response = await ServiceGraphql.request(USER_RESET_PASS, variables);
  return response.ChangePasswordForgot
};

export const graphUserChangePass = async (oldPass, newPass) => {
  const USER_CHANGE_PASS = gql`
  mutation ChangePasswordConsumer($newPass: String!, $oldPass: String!) {
    ChangePasswordConsumer(newPass: $newPass, oldPass: $oldPass)
  }
  `

  const variables = {
    "newPass": newPass,
    "oldPass": oldPass
  }

  const response = await ServiceGraphql.request(USER_CHANGE_PASS, variables);
  return response.ChangePasswordConsumer
};

export const graphCustomerLogout = async () => {
  const USER_LOGOUT = gql`
  mutation LogoutConsumer {
    LogoutConsumer
  }
  `

  const response = await ServiceGraphql.request(USER_LOGOUT);
  return response.LogoutConsumer
};

export const graqhUserFirstChangePass = async (token, oldPass, newPass) => {
  const USER_FIRST_CHANGE_PASS = gql`
  mutation ChangePasswordConsumer($newPass: String!, $oldPass: String!) {
    ChangePasswordConsumer(newPass: $newPass, oldPass: $oldPass)
  }
  `

  const variables = {
    "newPass": newPass,
    "oldPass": oldPass
  }

  const headers = {
      Authorization: token
  }

  const response = await ServiceGraphql.request(USER_FIRST_CHANGE_PASS, variables, headers);
  return response.ChangePasswordConsumer;
};
